import React, {useEffect, useState} from 'react';

import {
  TextCustom,
  TextLineHeight,
  TextSize,
  TextStyle,
  TextTag,
  TextType,
  TextWeight,
} from '@vw-marketing/us-components';

import {StyledFilterOnlineBuyingContainer} from './styles';
import {InfoToolTip} from '../info-tool-tip/InfoToolTip';
import {ToggleSwitch} from '../toggle-switch/ToggleSwitch';
import {userFilters} from '../../store/local-storage';
import {useReactiveVar} from '@apollo/client';
import {
  addFilterItem,
  isOnlineShoppingActive,
  removeFilterItem,
} from '../../utils/filters';
import {FilterItem} from '../../typing/used-inventory';
import {useHistory} from 'react-router';
import {updateUrlFilters} from '../../utils/navigation-url';

const onlineLabel = 'Build my deal';
const textLabelStyle: TextStyle = {
  fontWeight: TextWeight.bold,
  fontSize: TextSize.TextSize16,
  fontType: TextType.Copy,
  lineHeight: TextLineHeight.TextLineHeight20,
};

export const FilterOnlineBuying = () => {
  const history = useHistory();
  const currentFilters = useReactiveVar(userFilters);
  const FILTER_KEY_VALUE = 'Y';
  const FILTER_VALUE = 'Build my deal';
  const FILTER_TYPE = 'isOnlineShopping';
  const [isActiveDealerShopping, setIsActiveDealerShopping] = useState(
    isOnlineShoppingActive(currentFilters),
  );

  const onHandleFilterOnlineBuying = (isActive?: boolean) => {
    let updatedFilters = {...currentFilters, wasSearched: false};
    const filterElement: FilterItem = {
      isChecked: isActive || false,
      isDisabled: false,
      key: FILTER_KEY_VALUE,
      type: FILTER_TYPE,
      value: isActive ? FILTER_VALUE : 'false',
    };

    isActive
      ? updatedFilters = addFilterItem(filterElement, currentFilters)
      : updatedFilters = removeFilterItem(filterElement, currentFilters);

    userFilters(updatedFilters);
    updateUrlFilters(history, updatedFilters);
  };

  useEffect(() => {
    setIsActiveDealerShopping(isOnlineShoppingActive(currentFilters));
  }, [currentFilters]);

  return (
    <StyledFilterOnlineBuyingContainer className="online-buying-filter_container">
      <InfoToolTip />
      <TextCustom style={textLabelStyle} tag={TextTag.span}>
        {onlineLabel}
      </TextCustom>
      <ToggleSwitch
        onClick={onHandleFilterOnlineBuying}
        checked={isActiveDealerShopping}
      />
    </StyledFilterOnlineBuyingContainer>
  );
};
